import { render, staticRenderFns } from "./ConfigVisualizer.vue?vue&type=template&id=2463f80f"
import script from "./ConfigVisualizer.vue?vue&type=script&lang=js"
export * from "./ConfigVisualizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports